import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import Drilldown from 'react-highcharts/node_modules/highcharts/modules/drilldown';
Drilldown(ReactHighmaps.Highcharts);

import worldMap from '../utils/world';
import usMap from '../utils/us-all';
import toTitleCase from '../../utils/miscUtils';

const countryMapData = {
  'US': usMap
};

class Container extends Component {
  constructor(props) {
    super(props);
    const { map, stream } = this.props;
    this.state = { config: buildConfig(map, stream) };
  }

  componentDidUpdate() {
    if (!this.state.chart) return;
    const { map, stream } = this.props;
    const chart = this.state.chart.getChart();
    if (map) {
      let animationDelay = 0;
      // drilldown breaks if config is updated when not at top level
      if (chart.drilldownLevels && chart.drilldownLevels.length > 0) {
        chart.drillUp();
        animationDelay = 100;
      }
      let dd = getDrilldownSeries(map, stream);
      setTimeout(() => {
        chart.update({
          series: getSeries(map, stream),
          drilldown: { series: dd }
        }, true, true, false);
        // force drilldown update (HC bug)
        chart.options.drilldown = ReactHighmaps.Highcharts.merge(chart.options.drilldown, { series: dd });
        chart.hideLoading();
        chart.reflow();
      }, animationDelay);
    } else chart.showLoading();
  }
  shouldComponentUpdate(nextProps) {
    return nextProps.map !== this.props.map;
  }
  render() {
    return (
      <div className="insights-map">
        <ReactHighmaps
          isPureConfig
          config={this.state.config}
          domProps={{ className: 'sb-map' }}
          ref={chart => this.setState({ chart })}
        />
      </div>
    );
  }
}

Container.propTypes = {
  map: PropTypes.array,
  stream: PropTypes.string.isRequired
};

Container.defaultProps = {
  map: null,
};

export default Container;

const buildConfig = (data, stream) => {
   let config = {
    chart: {
      animation: false
    },
    credits: {
      enabled: false
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        align: 'left',
        verticalAlign: 'bottom',
        alignTo: 'spacingBox'
      }
    },
    colorAxis: {
      stops: [
        [0, '#A7E48A'],
        [0.25, '#6ABF43'],
        [1, '#33840E']
      ]
    },
    legend: {
      enabled: false
    },
    series: getSeries(data, stream),
    drilldown: {
      animation: { duration: 100 },
      series: getDrilldownSeries(data, stream)
    }
  };
  return config;
};

const getSeries = (data, stream) => ([
  {
    mapData: worldMap,
    name: 'World',
    data: (data || []).map(x => ({
        ...x,
        display: `Total ${toTitleCase(stream)}: ${x.value}`
    })),
    joinBy: ['iso-a2', 'code'],
    borderColor: '#BBBBBB',
    borderWidth: 0.2,
    states: {
      hover: {
        borderWidth: 1
      }
    },
    tooltip: {
      enabled: true,
      headerFormat: '',
      pointFormat:
                      '<span style="font-size: 12px">{point.name}</span><br/>' +
                      '<span style="font-size: 12px">{point.display}</span>'
    },
    turboThreshold: 0
  }
]);

const getDrilldownSeries = (data, stream) => {
  return (data || []).map(x => ({
    id: x.drilldown,
    name: toTitleCase(stream),
    mapData: countryMapData[x.code] || null,
    joinBy: ['name', 'state'],
    data: x.states.map(x => ({
        ...x,
        display: `Total ${toTitleCase(stream)}: ${x.value}`
    })),
    tooltip: {
      enabled: true,
      headerFormat: '',
      pointFormat:
              '<span style="font-size: 12px">{point.name}</span><br/>' +
              '<span style="font-size: 12px">{point.display}</span>'
    }
  })).filter(x => x.mapData !== null);
};
